import { render } from "./RiListViewNew.vue?vue&type=template&id=54640000"
import script from "./RiListViewNew.vue?vue&type=script&lang=js"
export * from "./RiListViewNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiListViewNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54640000"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54640000', __exports__)) {
    api.reload('54640000', __exports__)
  }
  
  module.hot.accept("./RiListViewNew.vue?vue&type=template&id=54640000", () => {
    api.rerender('54640000', render)
  })

}


export default __exports__